/*
 * Small conversion helpers, loaded with defer on every page.
 * - Delivery estimate on product pages (blocks/product-assurance.liquid)
 * - Color dot preview on product cards (snippets/card-color-swatches.liquid)
 */
(function () {
  'use strict';

  /* Delivery estimate ----------------------------------------------------- */

  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }

  function renderDeliveryEstimates(root) {
    root.querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
      const num = function (key) {
        return parseInt(el.dataset[key], 10) || 0;
      };
      const minDays = num('processingMin') + num('shippingMin');
      const maxDays = Math.max(num('processingMax') + num('shippingMax'), minDays);
      if (maxDays === 0) return;

      const now = new Date();
      let formatter;
      try {
        formatter = new Intl.DateTimeFormat(el.dataset.locale || undefined, {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        });
      } catch (error) {
        formatter = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' });
      }

      const start = formatter.format(addBusinessDays(now, minDays));
      const end = formatter.format(addBusinessDays(now, maxDays));
      const template = el.dataset.template || '[start] - [end]';
      const target = el.querySelector('[data-delivery-text]');
      if (!target) return;

      target.innerHTML = template
        .replace('[start]', '<strong>' + start + '</strong>')
        .replace('[end]', '<strong>' + end + '</strong>');
      el.hidden = false;
    });
  }

  /* Card color preview ---------------------------------------------------- */

  function previewVariant(event) {
    const dot = event.target.closest && event.target.closest('.card-swatches__dot[data-variant-image]');
    if (!dot) return;
    const card = dot.closest('product-card');
    if (!card) return;
    const gallery = card.querySelector('.card-gallery[data-color-pair]');
    const pairImages = gallery && gallery.querySelectorAll('slideshow-slide .product-media__image');
    if (dot.dataset.variantBackImage && pairImages && pairImages.length === 2) {
      if (gallery.dataset.previewSrc === dot.dataset.variantImage) return;
      const frontFirst = gallery.hasAttribute('data-pair-front-first');
      const back = pairImages[frontFirst ? 1 : 0];
      const front = pairImages[frontFirst ? 0 : 1];
      back.srcset = dot.dataset.variantBackSrcset || dot.dataset.variantBackImage;
      back.src = dot.dataset.variantBackImage;
      back.alt = dot.dataset.variantBackAlt || '';
      front.srcset = dot.dataset.variantSrcset || dot.dataset.variantImage;
      front.src = dot.dataset.variantImage;
      front.alt = dot.dataset.variantAlt || '';
      gallery.dataset.previewSrc = dot.dataset.variantImage;
      card.querySelectorAll('a[ref="cardGalleryLink"], a[ref="productCardLink"], a[ref="productTitleLink"]').forEach(function (link) {
        link.href = dot.href;
      });
      const slideshow = gallery.querySelector('slideshow-component');
      if (slideshow && typeof slideshow.select === 'function') {
        slideshow.select(0, undefined, { animate: false });
      }
      return;
    }
    const image = card.querySelector('.product-media__image, img');
    if (!image || image.dataset.previewSrc === dot.dataset.variantImage) return;

    image.dataset.previewSrc = dot.dataset.variantImage;
    image.srcset = dot.dataset.variantSrcset || dot.dataset.variantImage;
    image.src = dot.dataset.variantImage;
  }

  document.addEventListener('pointerover', previewVariant);
  document.addEventListener('focusin', previewVariant);

  /* Init ------------------------------------------------------------------ */

  function init() {
    renderDeliveryEstimates(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Product pages morph blocks on variant change, which resets the estimate to its hidden server state.
  let scheduled = false;
  new MutationObserver(function (records) {
    if (scheduled) return;
    const needsEstimate = records.some(function (record) {
      if (record.type === 'attributes') {
        return record.target.matches('[data-delivery-estimate][hidden]');
      }
      return Array.from(record.addedNodes).some(function (node) {
        return node instanceof Element && (
          node.matches('[data-delivery-estimate][hidden]') ||
          node.querySelector('[data-delivery-estimate][hidden]')
        );
      });
    });
    if (!needsEstimate) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      renderDeliveryEstimates(document);
    }, 0);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
})();

